import React, { useState } from "react";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { FiTruck, FiInfo, FiPlusCircle, FiList, FiCalendar } from "react-icons/fi";

function DeliveryCost() {
  const [delivery, setDelivery] = useState({
    category: "",
    minOrder: "",
    cost: "",
    from: new Date(),
    expiry: new Date(),
    status: "active",
  });

  const [deliveries, setDeliveries] = useState([
    { id: 1, category: "Electronics", minOrder: 500, cost: 50, from: "2025-01-01", expiry: "2025-12-31", status: "Active" },
    { id: 2, category: "Footwear", minOrder: 300, cost: 30, from: "2025-01-01", expiry: "2025-12-31", status: "Active" },
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDelivery({ ...delivery, [name]: value });
  };

  const handleDateChange = (name, date) => {
    setDelivery({ ...delivery, [name]: date[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newDelivery = {
      ...delivery,
      id: deliveries.length + 1,
      from: delivery.from.toISOString().split("T")[0],
      expiry: delivery.expiry.toISOString().split("T")[0],
      status: delivery.status === "active" ? "Active" : "Inactive",
    };
    setDeliveries([...deliveries, newDelivery]);
    setDelivery({ category: "", minOrder: "", cost: "", from: new Date(), expiry: new Date(), status: "active" });
  };

  return (
    <>
      <Topbar />
      <Sidebar />
      <main className="main-wrapper bg-light min-vh-100">
        <div className="main-content p-3 p-lg-4">
          
          {/* Header & Context */}
          <div className="row mb-4 align-items-center">
            <div className="col-md-6">
              <h4 className="fw-bold mb-1 text-dark">
                <FiTruck className="me-2 text-primary" /> Delivery Logistics
              </h4>
              <p className="text-muted small">Configure automated shipping costs based on order value and product categories.</p>
            </div>
            <div className="col-md-6 d-flex justify-content-md-end gap-2">
               <div className="bg-white px-3 py-2 rounded-3 shadow-sm border-start border-primary border-4">
                  <small className="text-muted d-block">Active Rules</small>
                  <span className="fw-bold">{deliveries.length} Categories</span>
               </div>
               <div className="bg-white px-3 py-2 rounded-3 shadow-sm border-start border-success border-4">
                  <small className="text-muted d-block">Avg. Cost</small>
                  <span className="fw-bold">Rs. 40.00</span>
               </div>
            </div>
          </div>

          <div className="row g-4">
            {/* Left: Configuration Form */}
            <div className="col-xl-4">
              <div className="card border-0 shadow-sm rounded-4 sticky-top" style={{ top: "100px", zIndex: 10 }}>
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <div className="bg-soft-primary p-2 rounded-3 me-3 text-primary">
                      <FiPlusCircle size={20} />
                    </div>
                    <h6 className="fw-bold mb-0">Create Cost Rule</h6>
                  </div>
                  
                  <div className="bg-light p-3 rounded-3 mb-4 border-start border-primary border-3">
                    <small className="text-dark fw-semibold d-block mb-1">How it works:</small>
                    <p className="extra-small text-muted mb-0">
                      When a customer buys from the selected <strong>Category</strong> and the total is above 
                      <strong> Min Order</strong>, the specified <strong>Delivery Cost</strong> will be applied.
                    </p>
                  </div>

                  <form onSubmit={handleSubmit} className="row g-3">
                    <div className="col-12">
                      <label className="form-label small fw-bold">Target Category</label>
                      <input type="text" className="form-control form-control-sm" name="category" placeholder="e.g. Groceries" value={delivery.category} onChange={handleChange} required />
                    </div>

                    <div className="col-6">
                      <label className="form-label small fw-bold">Min Order (₹)</label>
                      <input type="number" className="form-control form-control-sm" name="minOrder" placeholder="0.00" value={delivery.minOrder} onChange={handleChange} required />
                    </div>

                    <div className="col-6">
                      <label className="form-label small fw-bold">Shipping (₹)</label>
                      <input type="number" className="form-control form-control-sm" name="cost" placeholder="0.00" value={delivery.cost} onChange={handleChange} required />
                    </div>

                    <div className="col-12">
                      <label className="form-label small fw-bold">Active Period</label>
                      <div className="input-group input-group-sm">
                        <span className="input-group-text bg-white"><FiCalendar /></span>
                        <Flatpickr value={delivery.from} onChange={(date) => handleDateChange("from", date)} options={{ dateFormat: "Y-m-d" }} className="form-control" />
                        <Flatpickr value={delivery.expiry} onChange={(date) => handleDateChange("expiry", date)} options={{ dateFormat: "Y-m-d" }} className="form-control" />
                      </div>
                    </div>

                    <div className="col-12">
                      <label className="form-label small fw-bold">Visibility Status</label>
                      <select className="form-select form-select-sm" name="status" value={delivery.status} onChange={handleChange}>
                        <option value="active">Active (Immediate)</option>
                        <option value="inactive">Inactive (Draft)</option>
                      </select>
                    </div>

                    <div className="col-12 mt-4">
                      <button type="submit" className="btn btn-primary w-100 fw-bold py-2 shadow-sm rounded-3">
                        Deploy Rule
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* Right: Active Logistics Table */}
            <div className="col-xl-8">
              <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                <div className="card-header bg-white p-3 border-0 d-flex justify-content-between align-items-center">
                   <h6 className="fw-bold mb-0 text-dark"><FiList className="me-2" /> Live Logistics Rules</h6>
                   <div className="badge bg-light text-primary border border-primary px-3 py-2">System Sync: Live</div>
                </div>
                <div className="table-responsive">
                  <table className="table align-middle mb-0 custom-table">
                    <thead className="bg-light">
                      <tr>
                        <th className="ps-4">Rule Info</th>
                        <th>Threshold</th>
                        <th>Cost</th>
                        <th>Validity</th>
                        <th>Status</th>
                        <th className="text-end pe-4">Manage</th>
                      </tr>
                    </thead>
                    <tbody>
                      {deliveries.map((d) => (
                        <tr key={d.id}>
                          <td className="ps-4">
                            <div className="fw-bold text-dark">{d.category}</div>
                            <small className="text-muted extra-small">ID: #LOG-{d.id}</small>
                          </td>
                          <td>
                            <span className="small fw-semibold text-secondary">≥ ₹{d.minOrder}</span>
                          </td>
                          <td>
                            <div className="badge bg-soft-primary text-primary px-3 rounded-pill fw-bold">
                              ₹{d.cost}
                            </div>
                          </td>
                          <td>
                            <div className="extra-small fw-bold text-dark">{d.from}</div>
                            <div className="extra-small text-muted">to {d.expiry}</div>
                          </td>
                          <td>
                            <span className={`status-dot ${d.status === "Active" ? "bg-success" : "bg-danger"}`}></span>
                            <span className="small fw-bold ms-2">{d.status}</span>
                          </td>
                          <td className="text-end pe-4">
                            <button className="btn btn-sm btn-outline-light text-dark border shadow-sm px-3 rounded-pill extra-small fw-bold">Edit</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {deliveries.length === 0 && (
                  <div className="text-center py-5">
                    <FiInfo size={40} className="text-muted mb-3" />
                    <p className="text-muted">No delivery rules found. Create one on the left.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>

      <style>{`
        .bg-soft-primary { background-color: rgba(13, 110, 253, 0.1); }
        .extra-small { font-size: 11px; }
        .custom-table thead th { font-size: 11px; text-transform: uppercase; color: #6c757d; letter-spacing: 0.5px; padding: 15px 10px; border: none; }
        .custom-table tbody td { padding: 15px 10px; border-bottom: 1px solid #f8f9fa; }
        .status-dot { height: 8px; width: 8px; border-radius: 50%; display: inline-block; }
        .rounded-4 { border-radius: 1rem !important; }
        .form-label { margin-bottom: 0.4rem; color: #444; }
        .form-control, .form-select { border-radius: 8px; border: 1.5px solid #eee; transition: all 0.2s; }
        .form-control:focus { border-color: #0d6efd; box-shadow: none; }
        .input-group-text { border: 1.5px solid #eee; border-right: none; }
      `}</style>
    </>
  );
}

export default DeliveryCost;